import { isHdfcSmartBuyUrl, MMT_AUTH } from "../constants/TrainConstants";
import { getAndUpdateDvid } from 'MMT-UI/helpers/client/dvid/index.js';
import { getCookie } from "./trainUtils";

export const getMMTAuth = () => {
  try {
      const showHdfcSmartBuy = isHdfcSmartBuyUrl();
    if(showHdfcSmartBuy) {
      return getCookie('mmt-auth-hdfc_sb');
    }
    return getCookie(MMT_AUTH);
  } catch {
    console.error('mmtaut not found.')
    return null;
  }
}

export const getDeviceId = () => {
  try {
      const showHdfcSmartBuy = isHdfcSmartBuyUrl()
    if(showHdfcSmartBuy) {
      return getCookie('dvid-hdfc_sb');
    }
    return getAndUpdateDvid();
  } catch (e) {
    console.error('Device Id not found.')
    return 'rails-dweb';
  }
}

export const getSmartBuyHeader = () => {
  const showHdfcSmartBuy =isHdfcSmartBuyUrl();
  if (showHdfcSmartBuy) {
    return { affiliate: "HDFC_SB" };
  }
  return {};
};